import Vue from 'vue'
import VueRouter from 'vue-router'
import Shop from '../views/shop/index.vue'
import Verify from '../views/verify/verify.vue'
import Rules from '../views/rules/rules.vue'
import Activity from '../views/activity/activity.vue'
import AddActivity from '../views/activity/addActivity.vue'
import Zp from '../views/zp/zp.vue'
import Addposition from '../views/zp/addposition.vue'
import pubSuccess from '../views/success/pubsuccess.vue'
import acEdit from "../views/activity/EditActivity.vue"
import poEdit from "../views/zp/editPosition.vue"
import Service from "../views/service/service.vue"
import addService from "../views/service/addService.vue"
import editService from "../views/service/editService.vue"
import Company from "../views/company/company.vue"
import Resume from "../views/zp/resume.vue"
import Acform from "../views/activity/form.vue"
import Acinfo from "../views/activity/info.vue"
import Channel from "../views/activity/channel.vue"
import punSuccess from "../views/success/pubsuccess.vue"
import Login from "../views/shop/login.vue"
import orderDetail from "../views/activity/orderdetauk.vue"
import versuccess from "../views/success/versuccess.vue"
import cgsuccess from "../views/success/cgsuccess.vue"
Vue.use(VueRouter)

// 保存原push
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
// 同理替换replace
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err)
}

const routes = [{
        path: '/',
        name: 'Shop',
        component: Shop,
        meta: {
            keepAlive: true
        } // 需要缓存
    },
    {
        path: '/shopIndex',
        name: 'Shop',
        component: Shop,
        meta: {
            keepAlive: true
        } // 需要缓存
    },
    {
        path: '/verify',
        name: 'verify',
        component: Verify,
        meta: {
            title: '商家认证'
        }
    },
    {
        path: '/rules',
        name: 'rules',
        component: Rules,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/activity',
        name: 'activity',
        component: Activity,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/addActivity',
        name: 'addActivity',
        component: AddActivity,
        meta: {
            keepAlive: true
        } // 需要缓存
    },
    {
        path: '/zp',
        name: 'zp',
        component: Zp,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/addposition',
        name: 'addposition',
        component: Addposition,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/punSuccess',
        name: 'punSuccess',
        component: pubSuccess,
        meta: {
            title: '发布成功'
        }
    },
    {
        path: '/cgsuccess',
        name: 'cgsuccess',
        component: cgsuccess,
        meta: {
            title: '发布成功'
        }
    },
    {
        path: '/ActivityEdit',
        name: 'acEdit',
        component: acEdit,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/PositionEdit',
        name: 'poEdit',
        component: poEdit,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/versuccess',
        name: 'versuccess',
        component: versuccess,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/Service',
        name: 'service',
        component: Service,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/addService',
        name: 'addService',
        component: addService,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/editService',
        name: 'editService',
        component: editService,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/Company',
        name: 'Company',
        component: Company,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/Resume',
        name: 'Resume',
        component: Resume,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/Acform',
        name: 'Acform',
        component: Acform,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/Acinfo',
        name: 'Acinfo',
        component: Acinfo,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/Channel',
        name: 'Channel',
        component: Channel,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/Login',
        name: 'Login',
        component: Channel,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/orderDetail',
        name: 'orderDetail',
        component: orderDetail,
        meta: {
            title: '新势力'
        }
    }
]

const router = new VueRouter({
    mode: 'history', // 去掉#
    base: '/',
    routes,
    scrollBehavior(to, from, savedPosition) {
        // scrollBehavior keep‑alive激活不会触发，仅首次路由跳转生效
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    }
})

router.afterEach((to, from) => {
    // 立即滚动到顶部
    window.scrollTo(0, 0)
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0

    // 延迟滚动（等DOM渲染完）
    setTimeout(() => {
        // 尝试多个可能的容器
        const selectors = ['.scrollWrapper', '.app', '.container', '.main-content', '#app' ,'content']
        selectors.forEach(selector => {
            const el = document.querySelector(selector)
            if (el) {
                el.scrollTop = 0
            }
        })
        window.scrollTo(0, 0)
    }, 100)
})

export default router
